<template>
  <img
    :src="getImageSource"
    prevent-selection
    class="extra-avatar"
    alt="extra-avatar"
    :draggable="false"
    :style="{ maxWidth: getSize(), height: getSize() }"
    @error="onImg403"
    @click="emit('click')"
  />
</template>

<script setup>
  import placeholderImg from "@core/assets/img/user_photo_placeholder.svg";
  import placeholderWhiteImg from "@core/assets/img/user_photo_placeholder_white.svg";
  import placeholderPrimaryImg from "@core/assets/img/user_photo_placeholder_blue.svg";
  import { computed } from "vue";

  const emit = defineEmits(["onImg403", "click"]);

  // Props
  const props = defineProps({
    picture: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "115px",
    },
    white: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
  });

  // Computed
  const getImageSource = computed(() => {
    if (!props.picture) {
      if (props.white) {
        return placeholderWhiteImg;
      } else if (props.primary) {
        return placeholderPrimaryImg;
      }
      return placeholderImg;
    }
    return props.picture;
  });

  // Methods
  const onImg403 = function (event) {
    if (props.white) {
      event.target.src = placeholderWhiteImg;
    } else if (props.primary) {
      event.target.src = placeholderPrimaryImg;
    } else {
      event.target.src = placeholderImg;
    }
    emit("onImg403");
  };

  const getSize = function () {
    return props.size;
  };
</script>

<style lang="scss">
  .extra-avatar {
    border-radius: 50%;
    box-shadow: $img-shadow;
  }
</style>
